module.exports = __webpack_public_path__ + "static/media/445951484_390931453296998_8743954674163541044_n.a486fe66.jpg";